import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle login logic here
    console.log({
      email,
      password,
      rememberMe
    });
  };
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-893">
      <Header data-id="element-894" />
      <main className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-895">
        <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md" data-id="element-896">
          <div className="text-center" data-id="element-897">
            <h2 className="text-3xl font-extrabold text-gray-900" data-id="element-898">
              Welcome back
            </h2>
            <p className="mt-2 text-sm text-gray-600" data-id="element-899">
              Sign in to your Sunton Florist account
            </p>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-900">
            <div className="rounded-md shadow-sm -space-y-px" data-id="element-901">
              <div className="mb-4" data-id="element-902">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-903">
                  Email address
                </label>
                <div className="relative" data-id="element-904">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-905">
                    <MailIcon className="h-5 w-5 text-gray-400" data-id="element-906" />
                  </div>
                  <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="focus:ring-pink-500 focus:border-pink-500 block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-500" placeholder="Email address" data-id="element-907" />
                </div>
              </div>
              <div data-id="element-908">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-909">
                  Password
                </label>
                <div className="relative" data-id="element-910">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-911">
                    <LockIcon className="h-5 w-5 text-gray-400" data-id="element-912" />
                  </div>
                  <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="focus:ring-pink-500 focus:border-pink-500 block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-500" placeholder="Password" data-id="element-913" />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-914">
                    <button type="button" onClick={() => setShowPassword(!showPassword)} className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-915">
                      {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-916" /> : <EyeIcon className="h-5 w-5" data-id="element-917" />}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-918">
              <div className="flex items-center" data-id="element-919">
                <input id="remember-me" name="remember-me" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4 text-pink-700 focus:ring-pink-500 border-gray-300 rounded" data-id="element-920" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-921">
                  Remember me
                </label>
              </div>
              <div className="text-sm" data-id="element-922">
                <a href="#" className="font-medium text-pink-700 hover:text-pink-500" data-id="element-923">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div data-id="element-924">
              <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent rounded-md text-white bg-pink-700 hover:bg-pink-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500" data-id="element-925">
                Sign in
              </button>
            </div>
            <div className="text-center" data-id="element-926">
              <p className="text-sm text-gray-600" data-id="element-927">
                Don't have an account?{' '}
                <Link to="/signup" className="font-medium text-pink-700 hover:text-pink-500" data-id="element-928">
                  Sign up
                </Link>
              </p>
            </div>
          </form>
        </div>
      </main>
      <Footer data-id="element-929" />
    </div>;
}